import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Plus } from 'lucide-react';
import { Role } from '@/services/rolesPermissionsService';

interface RoleFormModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  editingRole: Role | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onReset: () => void;
}

export const RoleFormModal: React.FC<RoleFormModalProps> = ({
  isOpen,
  onOpenChange,
  editingRole,
  onSubmit,
  isLoading,
  onReset
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogTrigger asChild>
        <Button onClick={onReset}>
          <Plus className="w-4 h-4 mr-2" />
          Nuevo Rol
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {editingRole ? 'Editar Rol' : 'Crear Nuevo Rol'}
          </DialogTitle>
          <DialogDescription>
            {editingRole ? 'Modifica la información del rol seleccionado.' : 'Crea un nuevo rol en el sistema.'}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="name">Nombre técnico</Label>
            <Input
              id="name"
              name="name"
              defaultValue={editingRole?.name || ''}
              placeholder="ej: super_admin"
              required
            />
          </div>
          <div>
            <Label htmlFor="display_name">Nombre para mostrar</Label>
            <Input
              id="display_name"
              name="display_name"
              defaultValue={editingRole?.display_name || ''}
              placeholder="ej: Super Administrador"
            />
          </div>
          <div>
            <Label htmlFor="description">Descripción</Label>
            <Textarea
              id="description"
              name="description"
              defaultValue={editingRole?.description || ''}
              placeholder="Describe las responsabilidades de este rol"
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="color">Color</Label>
              <Input
                id="color"
                name="color"
                type="color"
                defaultValue={editingRole?.color || '#6b7280'}
              />
            </div>
            <div>
              <Label htmlFor="sort_order">Orden</Label>
              <Input
                id="sort_order"
                name="sort_order"
                type="number"
                defaultValue={editingRole?.sort_order || 0}
                min="0"
              />
            </div>
          </div>
          <div className="flex gap-2 pt-4">
            <Button type="submit" disabled={isLoading}>
              {editingRole ? 'Actualizar' : 'Crear'}
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => onOpenChange(false)}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};